namespace GeniuzPOS.ReportMasterData {
    export interface Report_1201_RecvRow {
        Id?: string;
        DocNo?: string;
        LineItemNo?: number;
        PaymentType?: number;
        PaymentName?: string;
        LineItemType?: number;
        ReceiptAmt?: number;
        RefType?: string;
        RefNo?: string;
        PointBurn?: number;
        Currency?: string;
        CurrencyCode?: string;
        CurrencyAmt?: number;
        ExchangeRate?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ApprovalCode?: string;
        InvoiceNo?: string;
    }

    export namespace Report_1201_RecvRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'ReportMasterData.Report_1201_Recv';
        export const lookupKey = 'Report_1201_RecvRow';

        export function getLookup(): Q.Lookup<Report_1201_RecvRow> {
            return Q.getLookup<Report_1201_RecvRow>('Report_1201_RecvRow');
        }
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            LineItemNo = "LineItemNo",
            PaymentType = "PaymentType",
            PaymentName = "PaymentName",
            LineItemType = "LineItemType",
            ReceiptAmt = "ReceiptAmt",
            RefType = "RefType",
            RefNo = "RefNo",
            PointBurn = "PointBurn",
            Currency = "Currency",
            CurrencyCode = "CurrencyCode",
            CurrencyAmt = "CurrencyAmt",
            ExchangeRate = "ExchangeRate",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ApprovalCode = "ApprovalCode",
            InvoiceNo = "InvoiceNo"
        }
    }
}
